import LoginScreen from "../components/loginScreen/LoginScreen";
import PasswordResetConfirmation from "../components/passwordResetConfirmation/PasswordResetConfirmation";
import ForgotPassword from "../components/forgotPassword/ForgotPassword";
import SetNewPasswordScreen from "../components/setNewPasswordScreen/SetNewPasswordScreen";
import SignUpScreen from "../components/loginScreen/SignUpScreen";
import SignupScreenConfirmation from "../components/loginScreen/SignupScreenConfirmation";
import AutoLogin from "../components/autoLogin/AutoLogin";
import { routes } from "./routes";

const NotAuthorized = () => <h1>You dont have access to this page</h1>;

const publicRoutes = [
  { path: routes.public.signIn, element: <LoginScreen /> },
  { path: routes.public.resetConfirm, element: <PasswordResetConfirmation /> },
  { path: routes.public.forgotPassword, element: <ForgotPassword /> },
  { path: routes.public.setPassword, element: <SetNewPasswordScreen /> },
  { path: routes.public.signUp, element: <SignUpScreen /> },
  { path: routes.public.signUpConfirm, element: <SignupScreenConfirmation /> },
  { path: routes.public.autoLogin, element: <AutoLogin /> },
  { path: routes.public.notAuthorized, element: <NotAuthorized /> },
];

export default publicRoutes;
